/** 
 * 页面基础配置， 在此出对页面进行配置注入，入按钮主题色、页面标题、页面描述等
 */
import { useEffect } from 'react';
import baseConf from './baseConf';

const BaseProvider = ({ children }) => {
  useEffect(() => {
    // 注入CSS变量到根元素
    const root = document.documentElement;
    
    // 注入主题色
    Object.entries(baseConf.cssVars).forEach(([key, value]) => {
      root.style.setProperty(key, value);
    });

    if (process.env.NODE_ENV === 'development') {
      console.log('配置已注入:', baseConf);
      console.log('CSS变量已注入:', baseConf.cssVars);
    }
  
    // 设置页面标题
    document.title = baseConf.seo.title;
    
    // 将配置暴露到全局（可选）
    window.BRAND_CONFIG = baseConf;
  }, []);

  return children;
};

export default BaseProvider;